// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "aircraft__nameTitle-2xqSo";
var _3 = "airline-mMNeY";
var _4 = "airline__number-1qyjQ";
var _5 = "airline__name-3qSAw";
export { _1 as "__esModule", _2 as "aircraft__nameTitle", _3 as "airline", _4 as "airline__number", _5 as "airline__name" }
export default { "__esModule": _1, "aircraft__nameTitle": _2, "airline": _3, "airline__number": _4, "airline__name": _5 }
